// import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import HeaderBar from "./HeaderBar";
import SideBar from "./SideBar";
import { useState } from "react";
import { CssBaseline, Tab, Tabs } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { PageProvider } from "../../contexts/PageProvider";
import useAuth from "../../hooks/useAuth";
import { roleOptions } from "../../utils/appRoles";
import './Core.css';

const mainContainerStyle = {
    display: "grid",
    gridAutoRows: "min-content auto min-content",
    height: "100vh",
    overflow: "hidden",
};

const menuAndContentCommonStyle = {
    height: "100%",
};

function AppPage() {
    const {auth} = useAuth();    
    const userType = auth?.user?.type;  
    const [open, setOpen] = useState(false);
    const [tabValue, setTabValue] = useState(1);
    const navigate = useNavigate();

    const handleChange = (_, newValue) => {
        setTabValue(newValue);
    };

    const TabIcon = ({icon}) => {
        return (
            <span style={{
                pointerEvents: 'none'
            }}>
                {icon}
            </span>
        );
    }

    function LinkTab(props) {
        return (
        <Tab
            {...props}
            component="a"
            onClick={(e) => {
            e.preventDefault();
            navigate(e.target.getAttribute('href'));
            }}
            icon={props?.icon && <TabIcon icon={props?.icon} />}
        />
        );
    }

    var homeLinkWidth = "100%";
    if (userType === roleOptions.HR || userType === roleOptions.ADMIN ) {
        homeLinkWidth = "34%";
    }

    return (
    <Box>
    <CssBaseline/>
    <Grid container sx={mainContainerStyle} spacing={0} columns={12}>
        {/* header */}
        <Grid item xs={12} sx={{zIndex: "2"}}>
            <Box>
                <HeaderBar {...{setOpen}}/>
            </Box>
        </Grid>
        {/* content, sidebar */}
        <Grid container sx={{position: "relative"}}>
            <Grid
                item
                xs={false}
                sx={{height: "100%", position: "absolute", zIndex: "3"}}
                className="side-bar-container">
                <Box
                    sx={{
                        ...menuAndContentCommonStyle,
                    }}>
                    <SideBar {...{open}}/>
                </Box>
            </Grid>
            <Grid item
                xs={true}
                style={{width: "100%", position: "absolute"}}
                className="content">
                <Box
                    sx={{
                        ...menuAndContentCommonStyle,
                    }}
                    style={{width: "100%"}}>
                    <Outlet/>
                </Box>
            </Grid>
        </Grid>
        {/* menu mobile */}
        <Grid
            item
            xs={true}
            className="mobile-menu-container">
            <div
                style={{
                    display: 'flex',
                    width: "100vw",
                    maxWidth: '100vw',
                    maxHeight: '11vh',
                    overflowX: 'auto',
                    justifyContent: 'center',
                    position: 'fixed',
                    bottom: '0', 
                    background: 'white',
                    zIndex: 4
                }}
            >
            <Tabs className="tabs" value={tabValue} onChange={handleChange} aria-label="icon tabs example">                    
                {userType === roleOptions.HR || userType === roleOptions.ADMIN ? 
                    <LinkTab sx={{width: "33%"}} href={'/users'} icon={<PeopleOutlineOutlinedIcon />} aria-label="Users" label="Utilisateurs" />
                : null}
                <LinkTab sx={{width: homeLinkWidth, maxWidth: homeLinkWidth}} href={'/'} icon={<HomeOutlinedIcon />} aria-label="Dashboard" label="Accueil" />
                {userType === roleOptions.HR || userType === roleOptions.ADMIN ? 
                    <LinkTab sx={{width: "33%"}} href={'/article'} icon={<DescriptionOutlinedIcon />} aria-label="Articles" label="Articles" />
                : null}                    
            </Tabs>
            </div>
        </Grid>
    </Grid>
    </Box>
    );
}

const Core = () => {
    return (
        <PageProvider>
            <AppPage/>
        </PageProvider>
    );
}

export default Core;
